/**
 * Carousel configuration for auth2 components
 * Centralized management of slides content and images
 */

// Import carousel images
import loginCarousel from '@/assets/img/carousel/login_carousel.webp'
import signupCarousel0 from '@/assets/img/carousel/signup_carousel_0.svg'
import signupCarousel1 from '@/assets/img/carousel/signup_carousel_1.svg'
import signupCarousel2 from '@/assets/img/carousel/signup_carousel_2.svg'
import signupCarousel3 from '@/assets/img/carousel/signup_carousel_3.svg'

/**
 * Carousel configuration object
 * Each slide contains content and image information
 */
export const CAROUSEL_CONFIG = {
  signup: {
    slides: [
      {
        id: 'slide0',
        image: {
          src: signupCarousel0,
          alt: 'auth.carousel.slide0.alt',
          class: 'carousel-bg-image'
        },
        content: {
          step: null,
          title: null,
          subtitle: 'auth.carousel.slide0.subtitle',
          text0: 'auth.carousel.slide0.text0',
          text1: null
        },
        cssClass: 'slide-item0'
      },
      {
        id: 'slide1',
        image: {
          src: signupCarousel1,
          alt: 'auth.carousel.slide1.alt',
          class: 'carousel-bg-image'
        },
        content: {
          step: null,
          title: null,
          subtitle: 'auth.carousel.slide1.subtitle',
          text0: 'auth.carousel.slide1.text0',
          text1: null
        },
        cssClass: 'slide-item1'
      },
      {
        id: 'slide2',
        image: {
          src: signupCarousel2,
          alt: 'auth.carousel.slide2.alt',
          class: 'carousel-bg-image'
        },
        content: {
          step: null,
          title: null,
          subtitle: 'auth.carousel.slide2.subtitle',
          text0: 'auth.carousel.slide2.text0',
          text1: null
        },
        cssClass: 'slide-item2'
      },
      {
        id: 'slide3',
        image: {
          src: signupCarousel3,
          alt: 'auth.carousel.slide3.alt',
          class: 'carousel-bg-image'
        },
        content: {
          step: null,
          title: null,
          subtitle: 'auth.carousel.slide3.subtitle',
          text0: 'auth.carousel.slide3.text0',
          text1: null
        },
        cssClass: 'slide-item3'
      }
    ]
  },

  login: {
    slides: [
      {
        id: 'singleslide',
        image: {
          src: loginCarousel,
          alt: 'auth.carousel.singleslide.alt',
          class: 'carousel-bg-image'
        },
        content: {
          step: null,
          title: null,
          subtitle: null,
          text0: null,
          text1: null
        },
        cssClass: 'slide-item3'
      }
    ]
  }
}

/**
 * Get carousel configuration for specific auth type
 * @param {string} authType - 'login' or 'signup'
 * @returns {Object} Carousel configuration
 */
export function getCarouselConfig(authType) {
  const config = CAROUSEL_CONFIG[authType]

  if (!config) {
    console.warn(
      `Unknown auth type: ${authType}. Falling back to login config.`
    )
    return CAROUSEL_CONFIG.login
  }

  return config
}

/**
 * Generate dynamic CSS for background images
 * This can be used to inject styles programmatically if needed
 * @param {string} authType - 'login' or 'signup'
 * @returns {string} CSS rules for background images
 */
export function generateCarouselCSS(authType) {
  const config = getCarouselConfig(authType)

  return config.slides
    .map(
      slide => `
    .${slide.cssClass} .slide-content {
      background-image: url('${slide.image.src}');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  `
    )
    .join('\n')
}

/**
 * Default carousel settings for vue-carousel
 */
export const CAROUSEL_SETTINGS = {
  perPage: 1,
  loop: true,
  autoplay: false,
  autoplayTimeout: 5000,
  speed: 500,
  easing: 'ease',
  paginationEnabled: true,
  paginationPosition: 'bottom-overlay',
  paginationPadding: 10,
  paginationSize: 10
}
